export default __webpack_public_path__ + "static/partnerstwo-89d057d66b41f3962faa21c4fc4bf2d6.png";